/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getSystemGameTypesByRootId',
  message: messages.SUCCESS_GET_SYSTEM_GAME_TYPES_BY_ROOT_ID,
  method: 'GET',
  path: '/system/:systemId/game-types/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_SYSTEM_GAME_TYPE,
  requestSchema: requestSchemas.systemGameTypes.getSystemGameTypesByRootId,
  scopes: [
    scopes.DEFAULT,
    scopes.SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID,
    scopes.SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID,
  ],
}];
